export const DT_RESOLUTION_VALIDITY_YEARS = 3;
export const DT_RESOLUTION_EXPIRY_WARNING_DAYS = 30;

/** Days remaining until `dateIso` (00:00 local), rounded; negative when already past. */
export function getDaysUntil(dateIso: string): number | null {
  const parsedDate = new Date(dateIso);
  if (Number.isNaN(parsedDate.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const targetStartOfDay = new Date(parsedDate);
  targetStartOfDay.setHours(0, 0, 0, 0);
  const millisecondsPerDay = 24 * 60 * 60 * 1000;
  return Math.round((targetStartOfDay.getTime() - today.getTime()) / millisecondsPerDay);
}

export function getDtResolutionExpiryDate(dtAuthorizationDate: string | undefined): Date | null {
  if (!dtAuthorizationDate?.trim()) return null;
  const parsedDate = new Date(dtAuthorizationDate + 'T00:00:00');
  if (Number.isNaN(parsedDate.getTime())) return null;
  const expiryDate = new Date(parsedDate);
  expiryDate.setFullYear(expiryDate.getFullYear() + DT_RESOLUTION_VALIDITY_YEARS);
  return expiryDate;
}

export function isDtResolutionExpired(dtAuthorizationDate: string | undefined): boolean {
  const expiryDate = getDtResolutionExpiryDate(dtAuthorizationDate);
  if (!expiryDate) return false;
  const daysUntilExpiry = getDaysUntil(expiryDate.toISOString());
  return daysUntilExpiry !== null && daysUntilExpiry <= 0;
}

export function getDtResolutionDaysUntilExpiry(
  dtAuthorizationDate: string | undefined,
): number | null {
  const expiryDate = getDtResolutionExpiryDate(dtAuthorizationDate);
  if (!expiryDate) return null;
  return getDaysUntil(expiryDate.toISOString());
}
